import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mandant-config';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantConfigEffects {

    MandantConfig$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MANDANT_CONFIG),
        mergeMap((x: ac.GetMandantConfigAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMandantConfig(x.keys).pipe(
                map((result: any) => {
                    return new ac.GetMandantConfigErfolgreichAction(result, x.keys, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMandantConfigFehlerAction(error, x.keys, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantVerwaltungService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantVerwaltungService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantVerwaltungService);
        }
        return this.service;
    }
}
